<template>
  <BaseScreen v-bind="screen">
    <Instruction
      v-bind="instruction"
      class="screen__stretch screen__offset-right"
    />
  </BaseScreen>
</template>

<script>
import screenMixin from '@/mixins/screen';
import Instruction from '@/components/Instruction.vue';

export default {
  name: 'AudioInstructionScreen',
  mixins: [screenMixin],
  components: {
    Instruction,
  },
  computed: {
    screenCase() {
      return 'STEP_AUDIO_INSTRUCTION';
    },
    titleText() {
      return this.$t('feedback.audio');
    },
    instruction() {
      return {
        title: {
          text: this.$t('feedback.startTitle'),
          size: 'l',
        },
        description: {
          text: this.$t('feedback.audioInstruction'),
          size: 'l',
        },
        button: {
          text: this.$t('feedback.start'),
          action: this.goNext,
        },
        imageName: 'feedback.jpg',
      };
    },
  },
  methods: {
    goNext() {
      this.$router.push(this.$router.options.paths.audioRecording);
    },
  },
};
</script>
